import React from 'react';
import { useApi } from '../../../contexts/ApiContext';
import { Button, Modal } from 'semantic-ui-react';
import { useHistory } from 'react-router-dom';
import { ProductCategory } from './product.type';

type Props = {
  id: number;
  name: ProductCategory['name'];
  onRequestClose: () => void;
}

export const DeleteCategory: React.FC<Props> = ({ id, name, onRequestClose }) => {
  const { callApi } = useApi();
  const history = useHistory();

  return (
    <Modal open onClose={onRequestClose} size="mini" >
      <Modal.Header>Delete product</Modal.Header>
      <Modal.Content>{`Are you sure to delete product ${name} and all its models`}</Modal.Content>
      <Modal.Actions>
        <Button
          negative
          onClick={() => callApi.delete(`/productCategory/${id}`).then(() => {
            onRequestClose();
            history.go(0);
          })}>Delete</Button>
        <Button onClick={onRequestClose}>Cancel</Button>
      </Modal.Actions>
    </Modal>
  );
}